export default __webpack_public_path__ + "static/media/logo.8bb77c6b.svg";